// extracted by mini-css-extract-plugin
export default {"base44Label":"_ZNvds"};